import React from "react";
import { StatusBullit } from "ui/components";
import { cx } from "utils/join-classnames";
import styles from "./StreamStatus.module.scss";

interface Props {
    online: boolean;
    className: string;
}

const StreamStatus: React.FC<Props> = ({ online, className }: Props) => (
    <div className={cx(styles.status, className)}>
        <div className={styles.status__text}>
            {online ? "online" : "offline"}
        </div>
        <StatusBullit
            status={online ? "online" : "offline"}
            className={styles.status__bullit}
        />
    </div>
);

export default StreamStatus;
